/* eslint-disable quotes */
export default [
  {
    id: 'd6a49ee5-bc27-457c-b240-50716cfbb982',
    title: 'Peer Group & Database',
    description: 'Your peer group, description of the CEM DC database.',
    order: 2,
    selected: false,
    color: '#65B7FF',
    type: 'section',
    permitAdd: true,
    objectAdd: {
      title: 'New subsection',
      type: 'subsection',
      droppable: true,
    },
    filterIds: ['BmGroup', 'MultiYear'],
    children: [
      {
        id: 'ec930bf8-a319-41a4-8535-9be125942f49',
        title: 'Participants',
        type: 'subsection',
        droppable: true,
        order: 0,
        children: [
          {
            id: '1b3f7e27-d92a-4b73-a767-9cf0e91de0ce',
            title: 'Participants Chart 1',
            type: 'chart',
            footnote: 'This is the pariticpants chart 1 footnote',
            chart: {
              icon: 'column',
              draggable: true,
              order: 0,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'column0',
                  header:
                    "$1.5T in assets this year CEM's DC database reached ",
                  text: 'The fee basis is the amount on which management fees are charged. For external private assets, the fee basis is often the commitment amount during the commitment period and unreturned invested capital (i.e., book cost) afterward. The fee basis for public market and internal assets is NAV, therefore it is not shown.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'column1',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Invested capital (i.e., book cost) afterward. The fee basis for public market and internal assets is NAV, therefore it is not shown.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'column2',
                  header: 'Assets this year.',
                  text: 'Aenean id velit vel ipsum pellentesque tincidunt nec et ex. Nam condimentum purus ac lacus tristique, eget auctor lacus pretium. Aliquam erat volutpat. Aenean pulvinar dui luctus elit vulputate accumsan. V',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'column3',
                  header: 'Pellentesque vestibulum lacinia hendrerit.',
                  text: 'Nunc nec augue ac turpis aliquam fermentum. Pellentesque vestibulum lacinia hendrerit. Nullam dictum pulvinar est, iaculis luctus sem iaculis ullamcorper. ',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'column5',
                  header: 'Donec placerat porta massa',
                  text: 'Pellentesque a neque urna. Vivamus ac rhoncus purus. Donec placerat porta massa, semper luctus sem posuere eu.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'column6',
                  header: 'Praesent mattis lorem ut.',
                  text: 'Suspendisse posuere at nulla placerat sollicitudin. Praesent mattis lorem ut lorem vestibulum dictum. Ut pulvinar ante ac libero vehicula, et tempus lorem pharetra. S',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'column7',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Aenean id velit vel ipsum pellentesque tincidunt nec et ex. Nam condimentum purus ac lacus tristique, eget auctor lacus pretium. Aliquam erat volutpat. A',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'column8',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: ' Nullam a dolor leo. In hac habitasse platea dictumst. Aliquam nec diam eget enim ornare pretium ac in sem. In finibus dui eu orci suscipit varius.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'column9',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: ' Proin facilisis nulla id mauris tincidunt, vitae interdum lorem suscipit. Praesent porttitor rhoncus ipsum ac ultricies. ',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'column12',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Nam dictum ligula luctus facilisis lobortis. Morbi convallis nisl dolor, quis tincidunt purus finibus a. Etiam posuere fermentum sodales. ',
                },
              ],
            },
            drilldowns: [
              {
                id: 'ac5871fb-0a27-45ab-8622-007ee582',
                title: 'Drilldown Test 1',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '5',
                        },
                      ],
                      chartOptions: 'column15',
                      header:
                        "CEM's DC database reached $1.5T in fees this year.",
                      text: 'Vivamus tincidunt efficitur elementum. Vestibulum et condimentum ipsum. Praesent ac augue pretium, fermentum nunc et, tempor lacus. ',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '4',
                        },
                      ],
                      chartOptions: 'column16',
                      header:
                        "CEM's DC database reached $1.5T in fees this year.",
                      text: 'Nulla facilisi. Donec erat diam, dignissim mollis libero quis, pellentesque tincidunt nisi. Donec eu turpis est. Suspendisse potenti. ',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '3',
                        },
                      ],
                      chartOptions: 'column17',
                      header:
                        "CEM's DC database reached $1.5T in fees this year.",
                      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus at lectus ut diam auctor pulvinar ut commodo metus. Aenean vehicula nunc ut metus porta, ut gravida risus eleifend.',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '2',
                        },
                      ],
                      chartOptions: 'column21',
                      header:
                        "CEM's DC database reached $1.5T in fees this year.",
                      text: 'Nullam a dolor leo. In hac habitasse platea dictumst. Aliquam nec diam eget enim ornare pretium ac in sem. In finibus dui eu orci suscipit varius. ',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '1',
                        },
                      ],
                      chartOptions: 'column22',
                      header:
                        "CEM's DC database reached $1.5T in fees this year.",
                      text: 'Proin facilisis nulla id mauris tincidunt, vitae interdum lorem suscipit. Praesent porttitor rhoncus ipsum ac ultricies.',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '5',
                        },
                      ],
                      chartOptions: 'column23',
                      header:
                        "CEM's DC database reached $1.5T in fees this year.",
                      text: "All base fees, before rebates, paid to third-party managers including investment management fees, manager-of-managers fees, commitment fees and 'hidden' fees netted from the returns.",
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '4',
                        },
                      ],
                      chartOptions: 'column24',
                      header:
                        "CEM's DC database reached $1.5T in fees this year.",
                      text: 'Nam dictum ligula luctus facilisis lobortis. Morbi convallis nisl dolor, quis tincidunt purus finibus a. Etiam posuere fermentum sodales. Nullam porta finibus massa, eu suscipit leo bibendum eu.',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '3',
                        },
                      ],
                      chartOptions: 'column28',
                      header:
                        "CEM's DC database reached $1.5T in fees this year.",
                      text: 'Aenean id velit vel ipsum pellentesque tincidunt nec et ex. Nam condimentum purus ac lacus tristique, eget auctor lacus pretium. Aliquam erat volutpat. ',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '2',
                        },
                      ],
                      chartOptions: 'column0',
                      header:
                        "CEM's DC database reached $1.5T in fees this year.",
                      text: 'Nam condimentum purus ac lacus tristique, eget auctor lacus pretium. Aliquam erat volutpat.',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '1',
                        },
                      ],
                      chartOptions: 'column1',
                      header:
                        "CEM's DC database reached $1.5T in fees this year.",
                      text: 'raesent ac augue pretium, fermentum nunc et, tempor lacus. Nulla facilisi. Donec erat diam, dignissim mollis libero quis, pellentesque tincidunt nisi. Donec eu turpis est. ',
                    },
                  ],
                },
                drilldowns: [
                  {
                    id: 'e9232b33-5143-4367-95cc-fe26c28bf1',
                    title: 'Drilldown Test 1.1',
                    type: 'chart',
                    chart: {
                      icon: 'column',
                      draggable: true,
                      order: 0,
                      data: [
                        {
                          filters: [
                            {
                              name: 'BmGroup',
                              value: 'USUniv',
                            },
                            {
                              name: 'MultiYear',
                              value: '5',
                            },
                          ],
                          chartOptions: 'column2',
                          header:
                            "CEM's DC database reached $1.5T in assets this year.",
                          text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                        },
                        {
                          filters: [
                            {
                              name: 'BmGroup',
                              value: 'USUniv',
                            },
                            {
                              name: 'MultiYear',
                              value: '4',
                            },
                          ],
                          chartOptions: 'column3',
                          header:
                            "CEM's DC database reached $1.5T in assets this year.",
                          text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                        },
                        {
                          filters: [
                            {
                              name: 'BmGroup',
                              value: 'USUniv',
                            },
                            {
                              name: 'MultiYear',
                              value: '3',
                            },
                          ],
                          chartOptions: 'column5',
                          header:
                            "CEM's DC database reached $1.5T in assets this year.",
                          text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                        },
                        {
                          filters: [
                            {
                              name: 'BmGroup',
                              value: 'USUniv',
                            },
                            {
                              name: 'MultiYear',
                              value: '2',
                            },
                          ],
                          chartOptions: 'column6',
                          header:
                            "CEM's DC database reached $1.5T in assets this year.",
                          text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                        },
                        {
                          filters: [
                            {
                              name: 'BmGroup',
                              value: 'USUniv',
                            },
                            {
                              name: 'MultiYear',
                              value: '1',
                            },
                          ],
                          chartOptions: 'column7',
                          header:
                            "CEM's DC database reached $1.5T in assets this year.",
                          text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                        },
                        {
                          filters: [
                            {
                              name: 'BmGroup',
                              value: 'GBLUniv',
                            },
                            {
                              name: 'MultiYear',
                              value: '5',
                            },
                          ],
                          chartOptions: 'column8',
                          header:
                            "CEM's DC database reached $1.5T in assets this year.",
                          text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                        },
                        {
                          filters: [
                            {
                              name: 'BmGroup',
                              value: 'GBLUniv',
                            },
                            {
                              name: 'MultiYear',
                              value: '4',
                            },
                          ],
                          chartOptions: 'column9',
                          header:
                            "CEM's DC database reached $1.5T in assets this year.",
                          text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                        },
                        {
                          filters: [
                            {
                              name: 'BmGroup',
                              value: 'GBLUniv',
                            },
                            {
                              name: 'MultiYear',
                              value: '3',
                            },
                          ],
                          chartOptions: 'column12',
                          header:
                            "CEM's DC database reached $1.5T in assets this year.",
                          text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                        },
                        {
                          filters: [
                            {
                              name: 'BmGroup',
                              value: 'GBLUniv',
                            },
                            {
                              name: 'MultiYear',
                              value: '2',
                            },
                          ],
                          chartOptions: 'column15',
                          header:
                            "CEM's DC database reached $1.5T in assets this year.",
                          text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                        },
                        {
                          filters: [
                            {
                              name: 'BmGroup',
                              value: 'GBLUniv',
                            },
                            {
                              name: 'MultiYear',
                              value: '1',
                            },
                          ],
                          chartOptions: 'column16',
                          header:
                            "CEM's DC database reached $1.5T in assets this year.",
                          text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                        },
                      ],
                    },
                  },
                ],
              },
              {
                id: '33178af9-e9fb-32-92e1-19b63a3a9ea4',
                title: 'Drilldown Test 2',
                type: 'chart',
                chart: {
                  icon: 'line',
                  draggable: true,
                  order: 1,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '5',
                        },
                      ],
                      chartOptions: 'line1',
                      header:
                        "CEM's DC database reached $1.5T in assets this year.",
                      text: 'Consulting includes all strategic consulting costs that pertain to the total fund (i.e., asset mix consulting) or that cannot be easily attributed to specific asset categories. Consulting costs that can be attributed to a single asset category (i.e., private asset manager searches) or to non-oversight support activities such as IT that are attributed to the asset categories, should be included with that asset category.',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '4',
                        },
                      ],
                      chartOptions: 'line2',
                      header:
                        "CEM's DC database reached $1.5T in assets this year.",
                      text: ' Suspendisse potenti. Vivamus ullamcorper magna finibus, commodo tellus vitae, laoreet arcu. Maecenas finibus sem consectetur porttitor interdum. Nulla facilisi.',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '3',
                        },
                      ],
                      chartOptions: 'line3',
                      header:
                        "CEM's DC database reached $1.5T in assets this year.",
                      text: 'Etiam sed ex consequat, egestas dolor eu, ultricies urna. Proin finibus a enim ac consequat. Mauris convallis diam nec gravida auctor. Mauris convallis commodo dui. ',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '2',
                        },
                      ],
                      chartOptions: 'line10',
                      header:
                        "CEM's DC database reached $1.5T in assets this year.",
                      text: 'Mauris consectetur nisi sed scelerisque mattis. Morbi mattis nec massa a viverra. In hendrerit nulla eu mauris dignissim,',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '1',
                        },
                      ],
                      chartOptions: 'line11',
                      header:
                        "CEM's DC database reached $1.5T in assets this year.",
                      text: 'Consulting includes all strategic consulting costs that pertain to the total fund (i.e., asset mix consulting) or that cannot be easily attributed to specific asset categories. Consulting costs that can be attributed to a single asset category (i.e., private asset manager searches) or to non-oversight support activities such as IT that are attributed to the asset categories, should be included with that asset category.',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '5',
                        },
                      ],
                      chartOptions: 'line13',
                      header:
                        "CEM's DC database reached $1.5T in assets this year.",
                      text: 'Vel blandit orci aliquam. Donec pharetra faucibus quam, vel ultrices orci pellentesque ut. Proin neque velit, elementum vitae est a,',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '4',
                        },
                      ],
                      chartOptions: 'line14',
                      header:
                        "CEM's DC database reached $1.5T in assets this year.",
                      text: 'tempus feugiat massa. Aenean nec feugiat ex, vitae bibendum justo. Ut eget est vitae felis ultricies consequat. Aliquam eu est vel erat rhoncus dapibus.',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '3',
                        },
                      ],
                      chartOptions: 'line18',
                      header:
                        "CEM's DC database reached $1.5T in assets this year.",
                      text: 'Nunc nec augue ac turpis aliquam fermentum. Pellentesque vestibulum lacinia hendrerit. Nullam dictum pulvinar est, iaculis luctus sem iaculis ullamcorper. ',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '2',
                        },
                      ],
                      chartOptions: 'line20',
                      header:
                        "CEM's DC database reached $1.5T in assets this year.",
                      text: 'Consulting includes all strategic consulting costs that pertain to the total fund (i.e., asset mix consulting) or that cannot be easily attributed to specific asset categories. Consulting costs that can be attributed to a single asset category (i.e., private asset manager searches) or to non-oversight support activities such as IT that are attributed to the asset categories, should be included with that asset category.',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                        {
                          name: 'MultiYear',
                          value: '1',
                        },
                      ],
                      chartOptions: 'line26',
                      header:
                        "CEM's DC database reached $1.5T in assets this year.",
                      text: 'Pellentesque sed luctus tellus. Phasellus a ante ut arcu interdum pellentesque. In egestas non ligula vel tristique. ',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: 'ae34bf45-5c85-4be5-8885-157cb7cd40b5',
            title: 'Participants Chart 2',
            type: 'chart',
            chart: {
              icon: 'bar',
              draggable: true,
              order: 1,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'bar1',
                  header:
                    "CEM's DC database fees reached $1.5T in assets this year.",
                  text: 'Suspendisse posuere at nulla placerat sollicitudin. Praesent mattis lorem ut lorem vestibulum dictum. Ut pulvinar ante ac libero vehicula, et tempus lorem pharetra. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Etiam orci turpis, dictum vitae tortor sed, vehicula suscipit ligula. Curabitur vehicula condimentum risus, quis suscipit lacus commodo sed. Cras et velit dolor.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'bar2',
                  header:
                    "CEM's DC database fees reached $1.5T in assets this year.",
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'bar3',
                  header:
                    "CEM's DC database fees reached $1.5T in assets this year.",
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'bar19',
                  header:
                    "CEM's DC database fees reached $1.5T in assets this year.",
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'bar25',
                  header:
                    "CEM's DC database fees reached $1.5T in assets this year.",
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'bar27',
                  header:
                    "CEM's DC database fees reached $1.5T in assets this year.",
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'bar1',
                  header:
                    "CEM's DC database fees reached $1.5T in assets this year.",
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'bar2',
                  header:
                    "CEM's DC database fees reached $1.5T in assets this year.",
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'bar3',
                  header:
                    "CEM's DC database fees reached $1.5T in assets this year.",
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'bar19',
                  header:
                    "CEM's DC database fees reached $1.5T in assets this year.",
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
              ],
            },
          },
          {
            id: 'e615250f-57f0-4d60-91d5-fad14a7fa6db',
            title: 'Participants Chart 3',
            type: 'chart',
            chart: {
              icon: 'column',
              draggable: true,
              order: 2,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'column21',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'column22',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'column23',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'column24',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'column28',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'column0',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'column1',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'column2',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'column3',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'column5',
                  header:
                    "CEM's DC database reached $1.5T in assets this year.",
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
              ],
            },
          },
        ],
      },
      {
        id: 'cd9294fe-702c-43ba-ae2d-49fa4221f4ae',
        title: 'Peer Names',
        type: 'subsection',
        droppable: true,
        order: 1,
        children: [
          {
            id: '58252bf3-77ff-4322-a3b9-83c2bdc92717',
            title: 'Peer Names Chart 1',
            type: 'chart',
            chart: {
              icon: 'column',
              draggable: true,
              order: 0,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'column21',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'column22',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'column23',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'column24',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'column28',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'column0',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'column1',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'column2',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'column3',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'column5',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
              ],
            },
          },
          {
            id: '7996d886-db25-4e3e-9ec3-6c07c2d01dea',
            title: 'Peer Names Chart 2',
            type: 'chart',
            chart: {
              icon: 'column',
              draggable: true,
              order: 1,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'column21',
                  header:
                    "CEM selects a peer group of similar-sized plans' fees",
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'column22',
                  header:
                    "CEM selects a peer group of similar-sized plans' fees",
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'column23',
                  header:
                    "CEM selects a peer group of similar-sized plans' fees",
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'column24',
                  header:
                    "CEM selects a peer group of similar-sized plans' fees",
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'column28',
                  header:
                    "CEM selects a peer group of similar-sized plans' fees",
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'column0',
                  header:
                    "CEM selects a peer group of similar-sized plans' fees",
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'column1',
                  header:
                    "CEM selects a peer group of similar-sized plans' fees",
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'column2',
                  header:
                    "CEM selects a peer group of similar-sized plans' fees",
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'column3',
                  header:
                    "CEM selects a peer group of similar-sized plans' fees",
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'column5',
                  header:
                    "CEM selects a peer group of similar-sized plans' fees",
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
              ],
            },
          },
          {
            id: 'ccff9a8b-17a2-4a50-abb6-48788b5e2a19',
            title: 'Peer Names Chart 3',
            type: 'chart',
            chart: {
              icon: 'column',
              draggable: true,
              order: 2,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'column21',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Performance fees and carried interest paid to underlying managers in fund of funds. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'column22',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Performance fees and carried interest paid to underlying managers in fund of funds. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'column23',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Performance fees and carried interest paid to underlying managers in fund of funds. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'column24',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Performance fees and carried interest paid to underlying managers in fund of funds. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'column28',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Performance fees and carried interest paid to underlying managers in fund of funds. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '5',
                    },
                  ],
                  chartOptions: 'column0',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Performance fees and carried interest paid to underlying managers in fund of funds. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '4',
                    },
                  ],
                  chartOptions: 'column1',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Performance fees and carried interest paid to underlying managers in fund of funds. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '3',
                    },
                  ],
                  chartOptions: 'column2',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Performance fees and carried interest paid to underlying managers in fund of funds. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '2',
                    },
                  ],
                  chartOptions: 'column3',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Performance fees and carried interest paid to underlying managers in fund of funds. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'MultiYear',
                      value: '1',
                    },
                  ],
                  chartOptions: 'column5',
                  header: 'CEM selects a peer group of similar-sized plans',
                  text: 'Performance fees and carried interest paid to underlying managers in fund of funds. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    id: '7bddd904-5748-488d-a87d-1ecd9f935173',
    title: 'Performance',
    description: 'Your peer group, description of the CEM DC database.',
    order: 3,
    selected: false,
    color: '#FFCD65',
    type: 'section',
    permitAdd: true,
    objectAdd: {
      title: 'New subsection',
      type: 'subsection',
      droppable: true,
    },
    filterIds: ['BmGroup', 'PerfFees'],
    children: [
      {
        id: '7120f3e9-85a6-4bfd-993a-016f0743a3f8',
        title: 'Total plan performance',
        type: 'subsection',
        droppable: true,
        order: 0,
        children: [
          {
            id: 'e594652b-4fdb-4a34-a1c3-5b3057ae2664',
            title: 'Total plan performance Chart 1',
            type: 'chart',
            chart: {
              icon: 'line',
              draggable: true,
              order: 0,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'line3',
                  header: 'Total plan performance Chart 1 header',
                  text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'line10',
                  header: 'Total plan performance Chart 1 header',
                  text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'line11',
                  header: 'Total plan performance Chart 1 header',
                  text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'line13',
                  header: 'Total plan performance Chart 1 header',
                  text: "Base fees, before rebates, paid to underlying managers in fund of funds. Includes investment management fees, commitment fees and 'hidden' fees netted from the returns.",
                },
              ],
            },
          },
          {
            id: 'da5de8db-105e-4af9-92ad-1de9970962f0',
            title: 'Total plan performance Chart 2',
            type: 'chart',
            chart: {
              icon: 'bar',
              draggable: true,
              order: 1,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'bar25',
                  header: 'Total plan performance Chart 2 header',
                  text: 'Consulting includes all strategic consulting costs that pertain to the total fund (i.e., asset mix consulting) or that cannot be easily attributed to specific asset categories. Consulting costs that can be attributed to a single asset category (i.e., private asset manager searches) or to non-oversight support activities such as IT that are attributed to the asset categories, should be included with that asset category.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'bar27',
                  header: 'Total plan performance Chart 2 header',
                  text: 'Consulting includes all strategic consulting costs that pertain to the total fund (i.e., asset mix consulting) or that cannot be easily attributed to specific asset categories. Consulting costs that can be attributed to a single asset category (i.e., private asset manager searches) or to non-oversight support activities such as IT that are attributed to the asset categories, should be included with that asset category.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'bar1',
                  header: 'Total plan performance Chart 2 header',
                  text: 'Consulting includes all strategic consulting costs that pertain to the total fund (i.e., asset mix consulting) or that cannot be easily attributed to specific asset categories. Consulting costs that can be attributed to a single asset category (i.e., private asset manager searches) or to non-oversight support activities such as IT that are attributed to the asset categories, should be included with that asset category.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'bar2',
                  header: 'Total plan performance Chart 2 header',
                  text: 'Consulting includes all strategic consulting costs that pertain to the total fund (i.e., asset mix consulting) or that cannot be easily attributed to specific asset categories. Consulting costs that can be attributed to a single asset category (i.e., private asset manager searches) or to non-oversight support activities such as IT that are attributed to the asset categories, should be included with that asset category.',
                },
              ],
            },
          },
          {
            id: '9e624cd5-c908-4cc4-9728-e40869b8b4ba',
            title: 'Total plan performance Chart 3',
            type: 'chart',
            chart: {
              icon: 'line',
              draggable: true,
              order: 2,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'column21',
                  header: 'Cost benchmark Chart 1 header with fees',
                  text: 'Include all performance fees and carried interest paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'line14',
                  header: 'Total plan performance Chart 3 header',
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'line18',
                  header: 'Total plan performance Chart 3 header',
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'line20',
                  header: 'Total plan performance Chart 3 header',
                  text: 'Custody and trustee costs should be gross before any reductions, if any, relating to securities lending or other revenues credited against fees. Also they should not include the custodians portion of securities lending revenue. Exclude the costs of preparing benefit checks. Fees for performance measurement services should be split from total custody costs and included in consulting & performance measurement.',
                },
              ],
            },
          },
        ],
      },
      {
        id: '268e32b5-a573-466c-9595-f7e9b10da06a',
        title: 'Cost benchmark',
        type: 'subsection',
        droppable: true,
        order: 1,
        children: [
          {
            id: 'aafcb4ff-a115-461d-a764-1f09e258c103',
            title: 'Cost benchmark Chart 1',
            type: 'chart',
            chart: {
              icon: 'column',
              draggable: true,
              order: 0,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'column22',
                  header: 'Cost benchmark Chart 1 header with fees',
                  text: 'Reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'column23',
                  header: 'Cost benchmark Chart 1 header with fees',
                  text: 'Include all performance fees and carried interest paid to third-party managers. performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'column24',
                  header: 'Cost benchmark Chart 1 header with fees',
                  text: 'third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'column28',
                  header: 'Cost benchmark Chart 1 header with fees',
                  text: 'Paid to third-party managers. For comparability performance fees should be reported on an accrual basis. Under the accrual method, performance fees are reported when they are earned, not when cash is paid.',
                },
              ],
            },
          },
          {
            id: '09b29a24-7333-466a-a3f6-ded9454b6666',
            title: 'Cost benchmark Chart 2',
            type: 'chart',
            chart: {
              icon: 'column',
              draggable: true,
              order: 1,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'column0',
                  header: 'Cost benchmark Chart 2 header',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'column1',
                  header: 'Cost benchmark Chart 2 header',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'column2',
                  header: 'Cost benchmark Chart 2 header',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'column3',
                  header: 'Cost benchmark Chart 2 header',
                  text: 'Internal and Other Costs\n\nFor externally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff whose primary responsibility is the selection, monitoring and oversight of external managers. If the staff are responsible for multiple asset classes, attribute their cost between the asset classes based on approximate time spent. Do not include the CIO (his cost should be included on the Expenses tab in oversight of the fund costs). Also, if you only have a small staff responsible for the entire fund, include their costs in oversight and not here.\n\nFor internally managed assets - the compensation, benefits and direct costs (i.e., travel, supplies, subscriptions, education) of staff managing internal portfolios. If the staff are responsible for multiple asset classes, their cost should be attributed between the asset classes based on approximate time spent. Do not include the CIO (the CIO’s cost should be include in oversight costs).\n\nInclude all consulting, research, legal, trading systems, and other third party costs that can be directly attributed to one or more asset classes.\n\nOverhead including rent, utilities, IT, investment accounting, financial control, HR, etc. should be allocated and accounted for in this survey. Ideally, costs should be allocated based on usage. A simpler and acceptable alternative allocation method is to allocate overhead costs based on relative direct head count',
                },
              ],
            },
          },
          {
            id: '7c1f78e5-8824-4805-b546-b920a5547da1',
            title: 'Cost benchmark Chart 3',
            type: 'chart',
            chart: {
              icon: 'column',
              draggable: true,
              order: 2,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'column5',
                  header: 'Cost benchmark Chart 3 header',
                  text: "Oversight fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'column6',
                  header: 'Cost benchmark Chart 3 header',
                  text: "For overseeing the entire fund or multiple asset classes and the fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'InclPerf',
                    },
                  ],
                  chartOptions: 'column7',
                  header: 'Cost benchmark Chart 3 header',
                  text: "Fees/salaries of the Board or Investment Committee. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                    {
                      name: 'PerfFees',
                      value: 'ExclPerf',
                    },
                  ],
                  chartOptions: 'column8',
                  header: 'Cost benchmark Chart 3 header',
                  text: "Oversight costs include the salaries and benefits of executives and their staff responsible for overseeing the entire. All costs associated with the above including fees/salaries, travel, director's insurance and attributed overhead are included. Given fiduciary obligations, having the lowest oversight costs is not necessarily optimal. Some sponsors with lower-than-average executive and administration costs compensate by having-higher-than average consulting costs.",
                },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    id: 'a25c396c-c691-4951-b6f6-746ca216483f',
    title: 'Plan structure',
    description: 'Your peer group, description of the CEM DC database.',
    order: 1,
    selected: false,
    color: '#7B6BFC',
    type: 'section',
    permitAdd: true,
    objectAdd: {
      title: 'New subsection',
      type: 'subsection',
      droppable: true,
    },
    filterIds: ['BmGroup', 'MultiYear'],
    children: [
      {
        id: 'd641cbdf-b307-4f0a-a7a7-9cd302d8bddb',
        title: 'Structure',
        type: 'subsection',
        droppable: true,
        order: 0,
        children: [
          {
            id: '0e5696f5-df3d-4758-bb5d-390db2db6ca7',
            title: 'Structure Chart 1',
            type: 'chart',
            filterIds: ['PerfFees'],
            chart: {
              icon: 'line',
              draggable: true,
              order: 0,
              data: [
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'USUniv',
                    },
                  ],
                  chartOptions: 'line26',
                  header: 'vs US Univ - Structure Chart 1',
                  text: 'Plans in the CEM database range from $1.5Bn to $30Bn in assets undermanagement.  The plans in your peer group range from $1Bn to $2.4 Bn, close to your size of $1.7Bn.',
                },
                {
                  filters: [
                    {
                      name: 'BmGroup',
                      value: 'GBLUniv',
                    },
                  ],
                  chartOptions: 'line29',
                  header: 'vs Global Univ - Structure Chart 1',
                  text: 'The plans in your peer group range from $1Bn to $2.4 Bn. Plans in the CEM database range from $1.5Bn to $30Bn in assets undermanagement. Close to your size of $1.7Bn.',
                },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    id: 'b60dc566-8956-4a9c-9833-af364911eb94',
    title: 'Monitoring Options',
    description: 'Table of your options.',
    order: 3,
    selected: false,
    color: '#FF8465',
    type: 'table',
    permitAdd: true,
    objectAdd: {
      title: 'New subsection',
      type: 'subsection',
      droppable: true,
    },
    filterIds: ['BmGroup'],
    children: [
      {
        id: '186d1d39-c459-4636-a302-41a312d8c368',
        title: 'Fixed Income',
        type: 'subsection',
        droppable: true,
        order: 1,
        children: [
          {
            id: 'caa11bce-3eff-4bbd-83b0-8eda4bcc4288',
            title: 'SweetSpot - Core Plus Bond',
            type: 'subsection',
            droppable: true,
            order: 10,
            children: [
              {
                id: '4bb58ef9-080f-4dfb-8ca3-e402fb1caa26',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column5',
                      header: 'Cost versus peer benchmark 5',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column21',
                      header: 'Cost versus peer benchmark 21',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '42150e26-d04d-49a8-86bf-932fb2f5e0f8',
            title: 'Whiterock - All Bond Market Index',
            type: 'subsection',
            droppable: true,
            order: 11,
            children: [
              {
                id: 'c6315b1f-64f6-4b33-af60-3ec5b06afe87',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column12',
                      header: 'Cost versus peer benchmark 12',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column16',
                      header: 'Cost versus peer benchmark 16',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: 'b85fc3ee-105a-4888-ac9b-71eabd8778df',
            title: 'SweetSpot - Managed Money Fund',
            type: 'subsection',
            droppable: true,
            order: 12,
            children: [
              {
                id: 'cc913e5c-6900-4e29-b085-ef271e0a9a65',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column7',
                      header: 'Cost versus peer benchmark 7',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column24',
                      header: 'Cost versus peer benchmark 24',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '2fc2792f-2f46-4fcc-8d5d-964968790d00',
            title: 'BlueRock - Money Market',
            type: 'subsection',
            droppable: true,
            order: 13,
            children: [
              {
                id: 'f75d95a3-d535-40ea-90fa-e5778c4af023',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column23',
                      header: 'Cost versus peer benchmark 23',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column16',
                      header: 'Cost versus peer benchmark 16',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: 'f1b603f0-1c43-4f0d-a56f-5d87b283df43',
            title: 'SweetSpot - Inflation Protection',
            type: 'subsection',
            droppable: true,
            order: 14,
            children: [
              {
                id: '3c058200-7f9c-4be5-b3b5-eb4d4bffa0d2',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column12',
                      header: 'Cost versus peer benchmark 12',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column23',
                      header: 'Cost versus peer benchmark 23',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        id: '63785a25-4c22-4525-87df-19dd27878959',
        title: 'Stock',
        type: 'subsection',
        droppable: true,
        order: 0,
        children: [
          {
            id: 'a181b2f5-5e3c-46db-986e-099fdd45c576',
            title: 'RightLane - Employer Common Stock Fund',
            type: 'subsection',
            droppable: true,
            order: 0,
            children: [
              {
                id: '59733f6d-0f56-4aba-8f9e-df632bf7974d',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column15',
                      header: 'Cost versus peer benchmark 15',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column3',
                      header: 'Cost versus peer benchmark 3',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: 'fd1e0e8b-667f-4bd2-be52-08e30f31c180',
            title: 'BlueRock - Counter Fund',
            type: 'subsection',
            droppable: true,
            order: 1,
            children: [
              {
                id: '1d89e116-a984-4083-94c6-ae619500ab46',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column16',
                      header: 'Cost versus peer benchmark 16',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column1',
                      header: 'Cost versus peer benchmark 1',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '50a0bcc4-1284-41f9-8616-fc5405cda2e9',
            title: 'BlueRock - US Market Index',
            type: 'subsection',
            droppable: true,
            order: 2,
            children: [
              {
                id: 'd44f045b-4587-4356-b49e-81447278279e',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column8',
                      header: 'Cost versus peer benchmark 8',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column0',
                      header: 'Cost versus peer benchmark 0',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: 'fbd7724d-660d-4f1a-be7a-faf04ba79b03',
            title: 'RightLane - Dividend Fund',
            type: 'subsection',
            droppable: true,
            order: 3,
            children: [
              {
                id: 'e2b9e8e6-7d8b-4e24-a35b-98fee2b30890',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column5',
                      header: 'Cost versus peer benchmark 5',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column9',
                      header: 'Cost versus peer benchmark 9',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '7bf51202-7244-49fc-953c-be6673af5f4e',
            title: 'RightLane - Large Investors Trust',
            type: 'subsection',
            droppable: true,
            order: 4,
            children: [
              {
                id: '59e3ebc1-06b2-4c39-bdb1-392efb92062b',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column12',
                      header: 'Cost versus peer benchmark 12',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column17',
                      header: 'Cost versus peer benchmark 17',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '4e71178b-7585-4989-81d9-093502fa52af',
            title: 'Whiterock - Growth Fund',
            type: 'subsection',
            droppable: true,
            order: 5,
            children: [
              {
                id: '301311f1-37e3-47cf-abcd-4ae6973ac56d',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column28',
                      header: 'Cost versus peer benchmark 28',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column16',
                      header: 'Cost versus peer benchmark 16',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: 'e86bae15-d01f-4ed3-ae8c-0edb3d7840d3',
            title: 'BlueRock - SmallMid Cap Core Fund',
            type: 'subsection',
            droppable: true,
            order: 6,
            children: [
              {
                id: 'c00fc740-d91a-4c7f-88fe-14bbc680046e',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column0',
                      header: 'Cost versus peer benchmark 0',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column8',
                      header: 'Cost versus peer benchmark 8',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '3ee69007-634e-4091-b39e-765199fd560f',
            title: 'BlueRock - EAFE-PAC Growth',
            type: 'subsection',
            droppable: true,
            order: 7,
            children: [
              {
                id: '06a388a6-cd3a-426d-b038-795a1c391507',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column1',
                      header: 'Cost versus peer benchmark 1',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column22',
                      header: 'Cost versus peer benchmark 22',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: 'eb097a4c-09e7-40a1-bf7f-5592281e643a',
            title: 'RightLane - Global Market Index',
            type: 'subsection',
            droppable: true,
            order: 8,
            children: [
              {
                id: '9c73110d-4e6e-4ce3-a143-6ee243c14796',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column23',
                      header: 'Cost versus peer benchmark 23',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column9',
                      header: 'Cost versus peer benchmark 9',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '46fe0609-26bf-4086-b1b8-43305e7a0069',
            title: 'RightLane - AllWorld Fund',
            type: 'subsection',
            droppable: true,
            order: 9,
            children: [
              {
                id: 'ef854d14-0d80-4ed8-812c-4f497c33ce23',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column21',
                      header: 'Cost versus peer benchmark 21',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column2',
                      header: 'Cost versus peer benchmark 2',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        id: 'adb2b385-3c7a-4d73-96fe-f276ba61d672',
        title: 'Target Date & Balanced',
        type: 'subsection',
        droppable: true,
        order: 2,
        children: [
          {
            id: '97e03dfc-8805-4ce9-9a97-eae79651242a',
            title: 'Stateguard - TargetDate Income',
            type: 'subsection',
            droppable: true,
            order: 15,
            children: [
              {
                id: 'b8275221-84ab-436f-b68c-019f8b9d40ea',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column17',
                      header: 'Cost versus peer benchmark 17',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column23',
                      header: 'Cost versus peer benchmark 23',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '8ccd8f4f-a6f4-4a36-bb3a-9568b887a102',
            title: 'Stateguard - TargetDate 2005',
            type: 'subsection',
            droppable: true,
            order: 16,
            children: [
              {
                id: 'f28e8789-a08e-44d8-ac91-66efe3623bf1',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column7',
                      header: 'Cost versus peer benchmark 7',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column7',
                      header: 'Cost versus peer benchmark 7',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: 'ce3008bb-409c-477f-81b5-6227bf44b767',
            title: 'Stateguard - TargetDate 2010',
            type: 'subsection',
            droppable: true,
            order: 17,
            children: [
              {
                id: '10b672af-ed0f-402b-baa3-978a88c5b477',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column24',
                      header: 'Cost versus peer benchmark 24',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column2',
                      header: 'Cost versus peer benchmark 2',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '218cec41-8595-4bdc-8632-d63b67da2c03',
            title: 'Stateguard - TargetDate 2015',
            type: 'subsection',
            droppable: true,
            order: 18,
            children: [
              {
                id: 'acffd5a2-80d9-4b81-adbd-cf3d9b460a6d',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column12',
                      header: 'Cost versus peer benchmark 12',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column1',
                      header: 'Cost versus peer benchmark 1',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '4db2e86f-2113-427d-a3cd-75b98a5b515a',
            title: 'Stateguard - TargetDate 2020',
            type: 'subsection',
            droppable: true,
            order: 19,
            children: [
              {
                id: '658e6932-c64d-4982-b879-7c1c22ffbedd',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column9',
                      header: 'Cost versus peer benchmark 9',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column8',
                      header: 'Cost versus peer benchmark 8',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '2c8abad0-f802-4e05-8a89-c88bc211b72e',
            title: 'Stateguard - TargetDate 2025',
            type: 'subsection',
            droppable: true,
            order: 20,
            children: [
              {
                id: '4d76ff0c-ceb9-4ee8-aa11-082bffcffe7f',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column22',
                      header: 'Cost versus peer benchmark 22',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column3',
                      header: 'Cost versus peer benchmark 3',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '6a93a03e-8729-4070-953f-f4a8742725f3',
            title: 'Stateguard - TargetDate 2030',
            type: 'subsection',
            droppable: true,
            order: 21,
            children: [
              {
                id: 'e4c49c4a-e33c-472a-8cc3-fb81b3a6bb0f',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column22',
                      header: 'Cost versus peer benchmark 22',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column24',
                      header: 'Cost versus peer benchmark 24',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: 'fa577d2a-8a58-4785-8bb9-ba3fc46e00d5',
            title: 'Stateguard - TargetDate 2035',
            type: 'subsection',
            droppable: true,
            order: 22,
            children: [
              {
                id: 'fd6fe895-3235-4ddf-a672-1cef2a040569',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column12',
                      header: 'Cost versus peer benchmark 12',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column15',
                      header: 'Cost versus peer benchmark 15',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '5cbb8d4f-73d8-4092-9a9e-435d03085095',
            title: 'Stateguard - TargetDate 2040',
            type: 'subsection',
            droppable: true,
            order: 23,
            children: [
              {
                id: '756b4721-be7f-43dc-bffa-4d31ebfca77a',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column23',
                      header: 'Cost versus peer benchmark 23',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column24',
                      header: 'Cost versus peer benchmark 24',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '97971c13-5e55-4aaf-9661-fe283b2866c7',
            title: 'Stateguard - TargetDate 2045',
            type: 'subsection',
            droppable: true,
            order: 24,
            children: [
              {
                id: '6e94c4dd-a0d2-403e-bf5b-295b4d570ad7',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column5',
                      header: 'Cost versus peer benchmark 5',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column21',
                      header: 'Cost versus peer benchmark 21',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: 'b441e71b-296e-469a-b0e1-af4278fc2ae0',
            title: 'Stateguard - TargetDate 2050',
            type: 'subsection',
            droppable: true,
            order: 25,
            children: [
              {
                id: '7a9e0737-eab9-44b1-83f2-d41dbc77f159',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column21',
                      header: 'Cost versus peer benchmark 21',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column3',
                      header: 'Cost versus peer benchmark 3',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '71d60929-3b7e-49eb-9d89-2b56dbd8ed53',
            title: 'Stateguard - TargetDate 2055',
            type: 'subsection',
            droppable: true,
            order: 26,
            children: [
              {
                id: 'a22bb01e-7ea8-4cfe-bd39-a3b5f3262f38',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column1',
                      header: 'Cost versus peer benchmark 1',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column15',
                      header: 'Cost versus peer benchmark 15',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '24474a4c-3ee4-48db-abd3-31851cd2e083',
            title: 'Stateguard - TargetDate 2060',
            type: 'subsection',
            droppable: true,
            order: 27,
            children: [
              {
                id: 'cd09a6f8-ee12-4941-9433-6f5c34cc674d',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column6',
                      header: 'Cost versus peer benchmark 6',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column12',
                      header: 'Cost versus peer benchmark 12',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
          {
            id: '8a1be676-d683-45e6-acb5-77aebde0e322',
            title: 'Stateguard - TargetDate 2065',
            type: 'subsection',
            droppable: true,
            order: 28,
            children: [
              {
                id: 'ebbd110e-5519-4733-a8a2-81539cfb6ae4',
                title: 'Cost versus peer benchmark',
                type: 'chart',
                chart: {
                  icon: 'column',
                  draggable: true,
                  order: 0,
                  data: [
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'USUniv',
                        },
                      ],
                      chartOptions: 'column28',
                      header: 'Cost versus peer benchmark 28',
                      text: 'Example text',
                    },
                    {
                      filters: [
                        {
                          name: 'BmGroup',
                          value: 'GBLUniv',
                        },
                      ],
                      chartOptions: 'column28',
                      header: 'Cost versus peer benchmark 28',
                      text: 'Example text',
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    ],
  },
]
